import React, { useState } from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import AddIcon from "@material-ui/icons/Add";
import UserFormDialog from "./UserFormDialog";
import UserType from "../../../types/User";
import ProjectType from "../../../types/Project";
import UiButton from "../../common/UiButton";
import { tableToolbarPrimaryButtonStyle } from "../../common/tableTheme";

const styles = (theme: Theme) =>
  createStyles({
    button: {
      padding: "9px 16px",
      minWidth: "250px",
    },
    buttonModern: tableToolbarPrimaryButtonStyle(theme),
    iconModern: {
      fontSize: 18,
    },
  });

interface PropsTypes {
  saveUser: Function;
  classes: any;
  projects: ProjectType[];
  toolbarVariant?: "default" | "modern";
}

const UsersActionButton: React.FC<PropsTypes> = (props) => {
  const { classes, saveUser, projects, toolbarVariant = "default" } = props;
  const isModern = toolbarVariant === "modern";
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openDialog = () => setIsDialogOpen(true);

  const closeDialog = () => setIsDialogOpen(false);

  const handleSave = (user: UserType) => {
    saveUser(user).then(() => closeDialog());
  };

  return (
    <React.Fragment>
      <UserFormDialog
        open={isDialogOpen}
        onClose={closeDialog}
        onSave={handleSave}
        projects={projects}
      />
      <UiButton
        color="secondary"
        variant="contained"
        onClick={openDialog}
        className={classNames({
          [classes.button]: !isModern,
          [classes.buttonModern]: isModern,
        })}
      >
        <AddIcon fontSize={isModern ? "small" : "default"} className={isModern ? classes.iconModern : undefined} />
        Nouvel utilisateur
      </UiButton>
    </React.Fragment>
  );
};

export default withStyles(styles)(UsersActionButton);
